import React from 'react'
import { motion } from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'
import { usePWA } from '../hooks/usePWA'

const { FiWifi, FiWifiOff, FiSmartphone, FiGlobe } = FiIcons

const PWAStatus = () => {
  const { isInstalled, isOnline } = usePWA()

  return (
    <div className="flex items-center space-x-2">
      {/* Installation Status */}
      {isInstalled && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="flex items-center space-x-1 bg-green-50 text-green-700 px-2 py-1 rounded-lg text-xs font-medium"
        >
          <SafeIcon icon={FiSmartphone} className="w-3 h-3" />
          <span>App</span>
        </motion.div>
      )}

      {/* Online/Offline Status */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className={`flex items-center space-x-1 px-2 py-1 rounded-lg text-xs font-medium ${
          isOnline
            ? 'bg-green-50 text-green-700'
            : 'bg-orange-50 text-orange-700'
        }`}
      >
        <SafeIcon icon={isOnline ? FiWifi : FiWifiOff} className="w-3 h-3" />
        <span>{isOnline ? 'Online' : 'Offline'}</span>
      </motion.div>
    </div>
  )
}

export default PWAStatus